import { render, staticRenderFns } from "./CityGender.vue?vue&type=template&id=2413b94c&"
import script from "./CityGender.vue?vue&type=script&lang=js&"
export * from "./CityGender.vue?vue&type=script&lang=js&"
import style0 from "./CityGender.vue?vue&type=style&index=0&id=2413b94c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports